export const locales = {
    'en-US': {
        skip: 'Skip Ad',
        learnMore: 'Learn More',
    },
    'de-DE': {
        skip: 'Werbung überspringen',
        learnMore: 'Mehr erfahren',
    },
    'es-ES': {
        skip: 'Saltar anuncio',
        learnMore: 'Saber más',
    },
    'fr-FR': {
        skip: 'Passer la pub',
        learnMore: 'En savoir plus',
    },
    'id-ID': {
        skip: 'Lewati iklan',
        learnMore: 'Pelajari lebih lanjut',
    },
    'it-IT': {
        skip: 'Salta pubblicità',
        learnMore: 'Scopri di più',
    },
    'pl-PL': {
        skip: 'Pomiń reklamę',
        learnMore: 'Dowiedz się więcej',
    },
    'pt-BR': {
        skip: 'Pular anúncio',
        learnMore: 'Saiba mais',
    },
    'tr-TR': {
        skip: 'Reklamı geç',
        learnMore: 'Daha fazla öğren',
    },
}
